const differentiators = [
  {
    icon: 'ri-award-line',
    title: 'Calidad Certificada',
    description:
      'Importamos demulsificantes formulados por Rixin Corp bajo estándares internacionales API, ASTM y NACE. Cada lote llega a Venezuela con certificado de calidad y es validado por Poly Alphs antes de la entrega.',
  },
  {
    icon: 'ri-time-line',
    title: 'Respuesta Ágil',
    description:
      'Entendemos la urgencia del sector. Garantizamos tiempos de respuesta rápidos, disponibilidad de inventario en Venezuela y entregas puntuales para sus operaciones críticas.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Soporte Técnico Dedicado',
    description:
      'Ingenieros de Poly Alphas Chemicals C.A. le acompañan desde la selección del producto importado hasta la optimización de dosis en campo. No vendemos productos: entregamos soluciones integrales.',
  },
  {
    icon: 'ri-links-line',
    title: 'Cadena de Suministro China–Venezuela',
    description:
      'Alianza directa con Rixin Corp, fabricante chino de demulsificantes. Importamos el producto ya formulado, lo validamos localmente y lo entregamos puesto en Venezuela, sin intermediarios.',
  },
  {
    icon: 'ri-ship-line',
    title: 'Logística Resuelta',
    description:
      'Nos encargamos de toda la cadena logística: compra en China, transporte marítimo internacional, gestión aduanal en Venezuela y entrega final en su campo petrolero. Usted recibe, lista para usar.',
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Relación a Largo Plazo',
    description:
      'Nos convertimos en su socio estratégico de importación. Estudiamos sus operaciones, anticipamos sus necesidades de inventario y garantizamos suministro continuo desde China. Su éxito es nuestro éxito.',
  },
];

export default function WhyUsGrid() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {differentiators.map((item) => (
              <div
                key={item.title}
                className="group bg-background-100 rounded-lg p-6 md:p-7 hover:bg-primary-50/30 transition-all duration-300 border border-background-200/60 hover:border-primary-200/50"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${item.icon} text-base`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed text-justify">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}